import axios from 'axios';
import urlBase from '../url-base';

const cache = {
  municipios: {}
};

const LookupHelper = {

obterMunicipio(idMunicipio, idUF) {
  if (!idMunicipio || !idUF) {
    return Promise.resolve('-');
  }

  const chave = String(idMunicipio);

  // ✅ cache global
  if (cache.municipios[chave]) {
    return Promise.resolve(cache.municipios[chave]);
  }

  return axios.post(
    urlBase.loopBack + 'APIS4s/Municipios',
    { idUF: Number(idUF) }
  )
  .then(res => {
    const municipios = Array.isArray(res.data)
      ? res.data
      : (res.data && res.data.data) || [];

    municipios.forEach(m => {
      // ✅ garantir chave string
      cache.municipios[String(m.Id)] = m.Nome;
    });

    return cache.municipios[chave] || '-';
  })
  .catch(err => {
    // eslint-disable-next-line no-console
    console.error('Erro ao buscar município', err);
    return '-';
  });
},

obterEnderecoPorCep(cep) {
  if (!cep) {
    return Promise.resolve(null);
  }
  const chave = String(cep).replace(/\D/g, '');

  // ✅ garante que o cache exista
  if (!cache.enderecosPorCep) {
    cache.enderecosPorCep = {};
  }

  // ✅ cache
  if (cache.enderecosPorCep[chave]) {
    return Promise.resolve(cache.enderecosPorCep[chave]);
  }

  return axios.post(
    urlBase.loopBack + 'APIS4s/Endereco',
    { cep: chave }
  )
  .then(res => {
    // ✅ normalização robusta do retorno
    const enderecoBruto =
      (res.data && res.data.data) ||
      (Array.isArray(res.data) ? res.data[0] : res.data) ||
      null;

    if (!enderecoBruto) {
      return null;
    }

    const enderecoNormalizado = {
      IdTipoLogradouro: enderecoBruto.IdTipoLogradouro || 0,
      TipoLogradouro: enderecoBruto.TipoLogradouro || '',
      Logradouro: enderecoBruto.Logradouro || '',
      IdBairro: enderecoBruto.IdBairro || 0,
      Bairro: enderecoBruto.Bairro || '',
      IdMunicipio: enderecoBruto.IdMunicipio || 0,
      Municipio: enderecoBruto.Municipio || '',
      IdUf: enderecoBruto.IdUf || 0,
      Uf: enderecoBruto.Uf || '',
      CodigoMunicipioIBGE: enderecoBruto.CodigoMunicipioIBGE || '',
      IdCentroCusto: enderecoBruto.IdCentroCusto || 0
    };

    // ✅ salva no cache
    cache.enderecosPorCep[chave] = enderecoNormalizado;

    return enderecoNormalizado;
  })
  .catch(err => {
    // eslint-disable-next-line no-console
    console.error('Erro ao buscar endereço por CEP', err);
    return null;
  });
}


};

export default LookupHelper;


/** WEBPACK FOOTER **
 ** ./src/util/LookupHelper.js
 **/